/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ChatIdentityLink = zod.object({
  actorUuid: zod.uuid().describe('The OE actor'),
  reachUserId: zod
    .string()
    .describe('Reach users.id — for a GROUP, the service user standing for it'),
});

export type ChatIdentityLink = zod.input<typeof ChatIdentityLink>;
export type ChatIdentityLinkOutput = zod.output<typeof ChatIdentityLink>;
